const defaultState = {
  list: [],
  item: null,
  itemCopy: null,
  loaded: true,
  subjects: [],
  subject_selcted: null,
  categories: [],
  categories_all: [],
  selected: [],
  list_trashed: [],
  category_selcted: null,
  trashed_count: 0,
}


const card = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_CARD_SUBJECTS':
      return {...state, subjects: action.data, loaded: true}
    case 'SET_CARD_ITEM_COPY':
      return {...state, itemCopy: action.data} 
    case 'GET_CARDS':
      return {...state, list: action.data, loaded: true}
    case 'DELETE_CARD':
      return {...state, list: state.list.filter(_i => _i.id != action.data), loaded: true}
    case 'DELETE_CARD_TRASHED':
      return {...state, list_trashed: state.list_trashed.filter(_i => _i.id != action.data), loaded: true}
    case 'UPDATE_CARD':
      return {
        ...state, 
        list: state.list.map(_i => _i.id == action.data.id ? {..._i, ...action.data} : {..._i}),
        loaded: true
      }
    case 'ADD_CARD':
      return {...state, list: state.selected.includes(action.data.category_id.toString()) ? [...state.list, action.data] : state.list, loaded: true}
    case 'SET_CARD_KEY':
      return {...state, [action.key]: action.data}
    case 'ADD_CARD_SUBJECT':
      return {...state, subjects: [...state.subjects, action.data], loaded: true}
    case 'UPDATE_CARD_SUBJECT':
      return {...state, 
        subjects: state.subjects.map(_i => _i.id == action.data.id ? {..._i, ...action.data} : {..._i}), 
        loaded: true,
        subject_selcted: action.data,
      }
    case 'DELETE_CARD_SUBJECT':
      return {
        ...state, 
        subjects: state.subjects.filter(_i => _i.id != action.data), 
        loaded: true,
        subject_selcted: state.subject_selcted && state.subject_selcted.id == action.data ? null : state.subject_selcted,
        categories: [],
        list: [],
      }
    case 'GET_CARD_CATEGORIES':
      return {...state, categories: action.data, loaded: true}
    case 'GET_CARD_CATEGORIES_ALL':
      return {...state, categories_all: action.data}
    case 'ADD_CARD_CATEGORY':
      return {...state, categories: [...state.categories, action.data], loaded: true}
    case 'UPDATE_CARD_CATEGORY':
      return {
        ...state, 
        categories: state.categories.map(_i => _i.id == action.data.id ? {..._i, ...action.data} : {..._i}), 
        loaded: true,
        category_selcted: action.data,
      }
    case 'DELETE_CARD_CATEGORY':
      return {
        ...state, 
        categories: state.categories.filter(_i => _i.id != action.data), 
        loaded: true,
        category_selcted: state.category_selcted && state.category_selcted.id == action.data ? null : state.category_selcted,
        list: state.list.filter(_i => _i.category_id != action.data)
      }
    default:
      return state
  }
}

export default card;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/card.js